import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkTab, UitkTabs } from 'uitk-react-tabs';
import { classNames } from 'uitk-react-utils';

import { FlightsForm, StaysForm, useSearchWidgetContext } from 'features/search-widget';

function Panel(): JSX.Element {
  const l10n = useLocalization();

  const { lobs, selectedLobIndex, setSelectedLobIndex } = useSearchWidgetContext();

  function handleLobTabSelect(selectedLobIndex: number): void {
    setSelectedLobIndex(selectedLobIndex);
  }

  if (lobs.length > 0) {
    return (
      <div className={classNames('panel', { 'panel--basic': lobs.length < 2 })}>
        <UitkCard className="panel__card" padded={true} border={true}>
          <div>
            <UitkTabs selectedTab={selectedLobIndex} onTabSelect={handleLobTabSelect}>
              {lobs.map((lob) => (
                <UitkTab
                  key={lob.id}
                  id={`${lob.id}Tab`}
                  name={
                    (lob.id === 'stays' && l10n.formatText('product.search.form.tab.label.stays')) ||
                    (lob.id === 'flights' && l10n.formatText('product.search.form.tab.label.flights'))
                  }
                >
                  <UitkCardContentSection padded={true}>
                    {(lob.id === 'stays' && <StaysForm />) || (lob.id === 'flights' && <FlightsForm />)}
                  </UitkCardContentSection>
                </UitkTab>
              ))}
            </UitkTabs>
          </div>
        </UitkCard>
      </div>
    );
  }

  return null;
}

export { Panel };
